// extracted by extract-css-chunks-webpack-plugin
module.exports = {"status-icon":"styles__status-icon___3qaMb","statusIcon":"styles__status-icon___3qaMb","status-svg":"styles__status-svg___3IsGK","statusSvg":"styles__status-svg___3IsGK","status-text":"styles__status-text___38OBN","statusText":"styles__status-text___38OBN"};
    if(module.hot) {
      // 1747791841633
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  